module.exports = __webpack_public_path__ + "img/symbol_0.c33a5fd7.png";